import {
  Button,
  Container,
  Fab,
  makeStyles,
  Modal,
  Snackbar,
  Tooltip,
} from "@material-ui/core";

import { Add as AddIcon } from "@material-ui/icons";
import React, { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import UploadAndDownloadService from "../services/uploadAndDownloadFile";
import PurchaseService from "../services/PurchaseOrder";
import $ from "jquery";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 200,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const UploadPOFile = ({
  setPurchaseOrderRelatedToFacture,
  setOnUploadFile,
  setInConfirmedPO,
  setFinishedPO,
  setInFineshedPo,
  purchaseOrderUploadInformation,
  setArchivedPO,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [factureImageFile, setFactureImageFile] = useState([]);

  // const [name, setName] = useState();
  // const [desc, setDesc] = useState();
  $(".custom-file-input").on("change", function () {
    var fileNameTwo = $(this).val().split("\\").pop();
    $(this)
      .siblings(".custom-file-label")
      .addClass("selected")
      .html(fileNameTwo);
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnUploadFile(false);
  };

  const onUploadFileToBackendHandler = () => {
    if (factureImageFile.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :aucun fichier ");
    } else {
      console.log(purchaseOrderUploadInformation);
      const uploadData = new FormData();
      uploadData.append("picture", factureImageFile);

      UploadAndDownloadService.uploadFile(
        "/retail/uploadFile/uploadImage/Facture",
        uploadData
      )
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            onAddFileToFactureDocumentInDB(
              purchaseOrderUploadInformation.state,
              purchaseOrderUploadInformation.reference,
              response.data.success
            );
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un erreur  ");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });

      setTimeout(setOnUploadFile(false), 5000);
      setOnUploadFile(false);
    }
  };

  const onUploadLocalFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFactureImageFile(e.target.files[0]);
    }
  };

  const onAddFileToFactureDocumentInDB = (state, reference, path) => {
    PurchaseService.updateFacturePathFileInPO(reference, path)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          if (purchaseOrderUploadInformation.isDeleted === 0) {
            if (state === 0) {
              let newState = purchaseOrderUploadInformation.poData.filter(
                (item) => item.reference !== reference
              );
              console.log(response.data.success);

              let new_array = add_items_to_array_at_position(
                newState,
                purchaseOrderUploadInformation.index,
                [response.data.success]
              );
              console.log(new_array);
              console.log(
                "purchaseOrderUploadInformation",
                purchaseOrderUploadInformation
              );

              setInConfirmedPO(new_array);
            } else if (state === 2) {
              let newState = purchaseOrderUploadInformation.poData.filter(
                (item) => item.reference !== reference
              );
              console.log(typeof path);

              let new_array = add_items_to_array_at_position(
                newState,
                purchaseOrderUploadInformation.index,
                [response.data.success]
              );
              console.log(new_array);

              setFinishedPO(new_array);
            } else if (state === 1) {
              let newState = purchaseOrderUploadInformation.poData.filter(
                (item) => item.reference !== reference
              );
              console.log(typeof path);

              let new_array = add_items_to_array_at_position(
                newState,
                purchaseOrderUploadInformation.index,
                [response.data.success]
              );
              console.log(new_array);

              setInFineshedPo(new_array);
            } else if (state === 3) {
              let newState = purchaseOrderUploadInformation.poData.filter(
                (item) => item.reference !== reference
              );

              let new_array = add_items_to_array_at_position(
                newState,
                purchaseOrderUploadInformation.index,
                [response.data.success]
              );
              console.log(new_array);

              setPurchaseOrderRelatedToFacture(new_array);
            }
          } else {
            let newState = purchaseOrderUploadInformation.poData.filter(
              (item) => item.reference !== reference
            );
            console.log(typeof path);

            let new_array = add_items_to_array_at_position(
              newState,
              purchaseOrderUploadInformation.index,
              [response.data.success]
            );
            console.log(new_array);

            setArchivedPO(new_array);
          }
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  function add_items_to_array_at_position(array, index, new_items) {
    return [...array.slice(0, index), ...new_items, ...array.slice(index)];
  }

  return (
    <>
      <Tooltip title="Add" aria-label="add" onClick={() => setOpen(true)}>
        <Fab color="primary" className={classes.fab}>
          <AddIcon />
        </Fab>
      </Tooltip>
      <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <label for="exampleInputFile10">Facture</label>
              <div class="input-group">
                <div class="custom-file">
                  <input
                    accept="application/pdf"
                    type="file"
                    className="custom-file-input"
                    id="exampleInputFile10"
                    onChange={onUploadLocalFileHandler}
                  />
                  <label class="custom-file-label" for="exampleInputFile10">
                    Entrer le fichier de bon de commande
                  </label>
                </div>
              </div>
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={onUploadFileToBackendHandler}
              >
                Ajouter
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Quitter
              </Button>
            </div>
          </form>
        </Container>
      </Modal>
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UploadPOFile;
